import { Grid, Modal, TextField, Paper, FormControlLabel, Switch, Typography, Button, MuiThemeProvider } from '@material-ui/core';
import { theme } from 'components/Theme';
import React, { Component } from 'react';

import LinksClipBoard from './LinksClipBoard';

class UrlCreator extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      utm_source: '',
      utm_medium: '',
      utm_content: '',
      utm_campaign: '',
      redirect: false,
      url: '',
    };
  }

  handleChange = (field: any, e: any) => {
    this.setState({ [field]: e.target.value });
  };

  handleChangeCheck = (field: any, e: any) => {
    this.setState({ [field]: e.target.checked });
  };

  createParameters = (baseUrl: string) => {
    let parameters = [];
    let firstparameter = '?';
    if (this.state.utm_source) {
      parameters.push('utm_source=' + this.state.utm_source);
    }

    if (this.state.utm_medium) {
      parameters.push('utm_medium=' + this.state.utm_medium);
    }

    if (this.state.utm_content) {
      parameters.push('utm_content=' + this.state.utm_content);
    }

    if (this.state.utm_campaign) {
      parameters.push('utm_campaign=' + this.state.utm_campaign);
    }

    if (this.state.redirect) {
      parameters.push('redirecionar=S');
    }

    if (!this.props.isProducer) {
      parameters.push('a=' + localStorage.getItem('id'));
    }

    if (parameters.length === 0) {
      return '';
    }

    if (baseUrl.indexOf('a=') >= 0) {
      firstparameter = '&';
    }

    return firstparameter + parameters.join('&');
  };
  render() {
    const urlsCheckouts = {
      urlChk: this.props.baseUrlChk ? this.props.baseUrlChk + this.createParameters(this.props.baseUrlChk) : '',
      urlSun: this.props.baseUrl + this.createParameters(this.props.baseUrl),
    };

    return (
      <MuiThemeProvider theme={theme}>
        <Modal
          open={this.props.open}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClose={this.props.handleClose}
        >
          <Paper
            elevation={10}
            style={{
              maxHeight: '90vh',
              overflow: 'auto',
              borderRadius: 4,
              padding: '1.5rem',
              width: '95vw',
            }}
          >
            <Typography variant='h6' style={{ color: '#192542' }}>
              Adicionar UTM&apos;s
            </Typography>
            <div className='m8' />
            <Typography variant='subtitle1' style={{ color: '#818B9D' }}>
              Crie sua URL para rastrear melhor seus resultados.
            </Typography>
            <div className='m16' />
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <TextField
                  helperText='Ex: google, facebook, newsletter'
                  label='Origem da campanha ( utm_source )'
                  fullWidth
                  value={this.state.utm_source}
                  onChange={(e: any) => this.handleChange('utm_source', e)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  helperText='Ex: mídia de marketing: cpc, banner, e-mail'
                  label='Mídia da campanha ( utm_medium )'
                  fullWidth
                  value={this.state.utm_medium}
                  onChange={(e: any) => this.handleChange('utm_medium', e)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  helperText='Ex: bannerPromocao, bannerBonus'
                  label='Conteúdo da campanha ( utm_content )'
                  fullWidth
                  value={this.state.utm_content}
                  onChange={(e: any) => this.handleChange('utm_content', e)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  helperText='Ex: CampanhaDeLancamento'
                  label='Origem da campanha ( utm_campaign )'
                  fullWidth
                  value={this.state.utm_campaign}
                  onChange={(e: any) => this.handleChange('utm_campaign', e)}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <FormControlLabel
                  control={<Switch color='primary' value={this.state.redirect} onChange={(e: any) => this.handleChangeCheck('redirect', e)} />}
                  label='Encaminhar UTMs do link para a URL do produtor'
                />
              </Grid>

              <LinksClipBoard urlChk={urlsCheckouts.urlChk} urlSun={urlsCheckouts.urlSun} />
            </Grid>
            <div className='m16' />
            <Grid container justify='flex-end'>
              <Button color='primary' size='large' onClick={this.props.handleClose}>
                Fechar
              </Button>
            </Grid>
          </Paper>
        </Modal>
      </MuiThemeProvider>
    );
  }
}

export default UrlCreator;
